module.exports = __webpack_public_path__ + "img/background-icna.44666d05.jpg";